import { $, _, Radio, Foundation, moment } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import InboomaBaseCollectionView from "../InboomaBaseCollectionView";
import { Notification } from "../../utils";

import FacilitiesItemTpl from "../../templates/facilities/FacilitiesItemTpl.html";

const FacilitiesItemView = InboomaBaseView.extend({
  template: FacilitiesItemTpl,
  className: "inb-c-item inb-c-item--facility row",

  _renderToggled: false,

  ui: {
    dropdown: ".inb-dropdown",
    toggleBtn: ".inb-toggle-facility-dd",
    removeSlot: ".inb-resource .inb-resource__remove",
    statusSelect: ".inb-status-select",
    removeFacility: ".inb-facility__delete",
  },

  events: {
    "change @ui.statusSelect": "_statusChanged",
    "click .inb-toggle-details  ": "_toggleResources",
    "click @ui.removeSlot": "_removeSlot",
    "click @ui.removeFacility": "_removeFacility",
    "click .inb-toggle-contingent-dd": "_initDropdown",
  },

  templateContext() {
    return {
      _,
      moment,
      last_update: this.model.get("modified") != "" ? moment(this.model.get("modified")) : "",
    };
  },

  modelEvents: {
    changed: "render",
  },

  onBeforeRender() {
    if (this.options.toggleContingentById == this.model.get("id")) {
      this._renderToggled = true;
      this.$el.addClass("toggled");
    }
  },

  _toggleResources(target) {
    $("#" + $(target.currentTarget).attr("data-inb-toggle")).toggleClass("active");
    this.$el.toggleClass("toggled");
  },

  _getResourceById(rid) {
    let resource;

    _.each(this.model.get("facility_slots").models, (_resource, key) => {
      if (_resource.get("id") == rid) {
        resource = _resource;
      }
    });

    return resource;
  },

  _statusChanged(target) {
    target.preventDefault();

    const t = $(target.currentTarget),
      facility_slot = this._getResourceById(
        t.closest(".inb-resource").attr("data-inb-resource-id"),
      ),
      val = t.val();

    if (val != "") {
      // leave this here

      facility_slot.save({ status: val }, { patch: true });

      new Notification({
        message: this.t("updated_${a}", { a: this.t("slot") }, "capital"),
        duration: 9000,
        type: "success",
        closeable: true,
        icon: "fi fi-check",
      });
    }
  },

  _removeSlot(target) {
    target.preventDefault();

    if (confirm(this.t("really_remove"))) {
      const that = this,
        facility_slot = this._getResourceById(
          $(target.currentTarget).closest(".inb-resource").attr("data-inb-resource-id"),
        );

      facility_slot.destroy({
        success: function (model, response) {
          $(target.currentTarget).closest(".inb-resource").fadeOut("fast");

          new Notification({
            message: that.t("removed_${a}", { a: that.t("slot") }, "capital"),
            duration: 5000,
            closeable: true,
            icon: "fi fi-check",
          });

          // if (resource.collection.length == 0) {
          that.render();
          //  }
        },
      });
    }
  },

  _removeFacility(target) {
    target.preventDefault();

    const that = this;

    if (confirm(this.t("really_remove"))) {
      this.model.destroy({
        success: (model, response) => {
          that.$el.fadeOut("fast").remove();

          const success = new Notification({
            message: that.t("removed_${a}", { a: that.t("facility") }, "capital"),
            duration: 5000,
            closeable: true,
            icon: "fi fi-check",
          });
        },
      });
    }
  },

  _initDropdown() {
    this._dropdown = new Foundation.Dropdown(this.getUI("dropdown"));
  },
});

export default InboomaBaseCollectionView.extend({
  childView: FacilitiesItemView,
  template: _.noop,

  childViewOptions() {
    return {
      toggleContingentById:
        typeof this.options.toggleId != "undefined" ? this.options.toggleId : null,
    };
  },

  initialize() {
    this.$el.html(""); // Required because Facilities does not have any own controller

    InboomaBaseCollectionView.prototype.initialize.apply(this);

    this.render();
  },

  onRender() {
    $(".inb-c-loader").hide();

    if ($(".inb-c-item.toggled").length >= 1) {
      $("html,body").scrollTop($(".inb-c-item.toggled").offset().top - 10);
    }
  },
});
